/**
 * @license ngx-ui-scroll
 * MIT license
 */

import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Directive, TemplateRef, ViewContainerRef, ComponentFactoryResolver, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Workflow, makeDatasource, AdapterPropName, EMPTY_ITEM } from 'vscroll';
import { Subject, BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["ui-scroll", ""];
function UiScrollComponent_div_1_ng_template_1_Template(rf, ctx) { }
const _c1 = function (a0, a1, a2, a3) { return { $implicit: a0, index: a1, odd: a2, even: a3 }; };
function UiScrollComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, UiScrollComponent_div_1_ng_template_1_Template, 0, 0, "ng-template", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("position", item_r1.invisible ? "fixed" : null)("left", item_r1.invisible ? "-99999px" : null);
    ɵngcc0.ɵɵattribute("data-sid", item_r1.nodeId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(7, _c1, item_r1.data, item_r1.$index, item_r1.$index % 2, !(item_r1.$index % 2)));
} }
var consumer = {
    name: 'ngx-ui-scroll',
    version: '2.0.0-rc.6'
};

/* tslint:disable:component-selector */
class UiScrollComponent {
    constructor(changeDetector, elementRef) {
        this.changeDetector = changeDetector;
        this.elementRef = elementRef;
        // the only template variable
        this.items = [];
    }
    ngOnInit() {
        this.workflow = new Workflow({
            consumer,
            element: this.elementRef.nativeElement,
            datasource: this.datasource,
            run: (items) => {
                if (!items.length && !this.items.length) {
                    return;
                }
                this.items = items;
                this.changeDetector.detectChanges();
            }
        });
    }
    ngOnDestroy() {
        this.workflow.dispose();
    }
}
UiScrollComponent.ɵfac = function UiScrollComponent_Factory(t) { return new (t || UiScrollComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
UiScrollComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UiScrollComponent, selectors: [["", "ui-scroll", ""]], attrs: _c0, decls: 3, vars: 1, consts: [["data-padding-backward", ""], [3, "position", "left", 4, "ngFor", "ngForOf"], ["data-padding-forward", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function UiScrollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, UiScrollComponent_div_1_Template, 2, 12, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
UiScrollComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollComponent, [{
        type: Component,
        args: [{
                selector: '[ui-scroll]',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `
    <div data-padding-backward></div>
    <div
      *ngFor="let item of items"
      [attr.data-sid]="item.nodeId"
      [style.position]="item.invisible ? 'fixed' : null"
      [style.left]="item.invisible ? '-99999px' : null">
      <ng-template
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          $implicit: item.data,
          index: item.$index,
          odd: item.$index % 2,
          even: !(item.$index % 2)
      }"></ng-template>
    </div>
    <div data-padding-forward></div>`
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, null); })();

class UiScrollDirective {
    constructor(templateRef, viewContainer, resolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.resolver = resolver;
    }
    set uiScrollOf(datasource) {
        this.datasource = datasource;
    }
    ngOnInit() {
        const compFactory = this.resolver.resolveComponentFactory(UiScrollComponent);
        const componentRef = this.viewContainer.createComponent(compFactory, void 0, this.viewContainer.injector);
        componentRef.instance.datasource = this.datasource;
        componentRef.instance.template = this.templateRef;
    }
}
UiScrollDirective.ɵfac = function UiScrollDirective_Factory(t) { return new (t || UiScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
UiScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiScrollDirective, selectors: [["", "uiScroll", "", "uiScrollOf", ""]], inputs: { uiScrollOf: "uiScrollOf" } });
UiScrollDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
UiScrollDirective.propDecorators = {
    uiScrollOf: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollDirective, [{
        type: Directive,
        args: [{ selector: '[uiScroll][uiScrollOf]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { uiScrollOf: [{
            type: Input
        }] }); })();

class UiScrollModule {
}
UiScrollModule.ɵfac = function UiScrollModule_Factory(t) { return new (t || UiScrollModule)(); };
UiScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiScrollModule });
UiScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UiScrollComponent,
                    UiScrollDirective
                ],
                imports: [CommonModule],
                entryComponents: [UiScrollComponent],
                exports: [UiScrollDirective],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiScrollModule, { declarations: function () { return [UiScrollComponent, UiScrollDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [UiScrollDirective]; } }); })();

const getBooleanSubjectPropConfig = () => ({
    source: new Subject(),
    emit: (source, value) => source.next(value)
});
const getItemBehaviorSubjectPropConfig = () => ({
    source: new BehaviorSubject(EMPTY_ITEM),
    emit: (source, value) => source.next(value)
});
const getAdapterConfig = () => ({
    mock: false,
    reactive: {
        [AdapterPropName.init$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.isLoading$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.loopPending$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.firstVisible$]: getItemBehaviorSubjectPropConfig(),
        [AdapterPropName.lastVisible$]: getItemBehaviorSubjectPropConfig(),
        [AdapterPropName.bof$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.eof$]: getBooleanSubjectPropConfig(),
    }
});
const AngularDatasource = makeDatasource(getAdapterConfig);

export { AngularDatasource as Datasource, UiScrollDirective, UiScrollModule, UiScrollComponent as ɵa };

